import { render } from "./AgenteJornada.vue?vue&type=template&id=889eb71e&scoped=true"
import script from "./AgenteJornada.vue?vue&type=script&lang=ts"
export * from "./AgenteJornada.vue?vue&type=script&lang=ts"

import "./AgenteJornada.vue?vue&type=style&index=0&id=889eb71e&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-889eb71e"

export default script